import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { AuthCallback } from "@/components/AuthCallback";
import { PaymentSuccessPage, PaymentCancelPage } from "@/pages/PaymentPages";
import AdminPage from "@/pages/AdminPage";
import HomePage from "@/pages/HomePage";
import GiuliaPage from "@/pages/GiuliaPage";
import HeroPreviewPage from "@/pages/HeroPreviewPage";
import TeaserPreviewPage from "@/pages/TeaserPreviewPage";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/giulia" element={<GiuliaPage />} />
      <Route path="/preview/hero" element={<HeroPreviewPage />} />
      <Route path="/preview/teaser" element={<TeaserPreviewPage />} />
      <Route path="/payment/success" element={<PaymentSuccessPage />} />
      <Route path="/payment/cancel" element={<PaymentCancelPage />} />
      <Route path="*" element={<HomePage />} />
    </Routes>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter><AppRouter /></BrowserRouter>
      <Toaster theme="dark" position="bottom-center" richColors />
    </ErrorBoundary>
  );
}